<template>
	<main class="px-2 md:px-6 mb-12">
		<section v-if="qurbans.length > 0">
			<div class="flex mb-6">
				<h4><strong>Qurban</strong></h4>
			</div>
			<section>
                <qurban-carousel 
                    :datas="qurbans"
                    :query="mitra_id ? `?m=${mitra_id}` : ''"
                >
                    <template #header>
                        <div></div>
                    </template>
                </qurban-carousel>
            </section>
		</section>
	</main>
</template>
<script>
import { mapState } from 'vuex';

export default {
    components: {
        QurbanCarousel: () => import('@/views/home/qurban/components/QurbanCarousel.vue')
    },
    data: () => ({
        datas: []
    }),
    computed: {
        ...mapState('qurban', ['qurbans'])
    },
    props: {
        user_id: {
            required: true
        },
        mitra_id: {
            type: [String, Number],
            default: null
        }
    },
    methods: {
        imageLink (campaign) {
            if (campaign.file !== null) {
            return `${process.env.VUE_APP_STORAGE  }/${  campaign.file}`;
            }
                    
            return 'https://imgix.kitabisa.com/3f39c017-d125-46b3-9520-657ba793d409.jpg?ar=16:9&w=664&auto=format,compress&fm=pjpg&cs=tinysrgb&fit=scale';
        },
        donationPercent (campaign) {
            return Math.ceil((parseInt(campaign.donasi_terkumpul) / parseInt(campaign.donasi)) * 100);
        },
        getQurban() {
            const params = {
                user_id: this.user_id,
                status: 1,
                length: 9
            };

            this.$store.dispatch('qurban/getData', params)
            .then(() => this.datas = this.qurbans)
            .catch(e => {
                console.error(e);
                return false;
            });
        }
    },
    created() {
        this.getQurban();
    }
};
</script>